import React, { useState } from 'react';
import { Button, Form } from 'antd';
import styles from './index.module.scss';
import PasswordLoginPriv from 'lib/publicUsecase/PasswordLoginPriv';
import { noop } from 'lodash';
import LoginAgreementItem from 'component/AuthForm/LoginAgreementItem';
import LoginGraphicCapatchaItem from 'component/AuthForm/LoginGraphicCapatchaItem';
import LoginAccountItem from 'component/AuthForm/LoginAccountItem';
import LoginPasswordItem from 'component/AuthForm/LoginPasswordItem';
import { Pivot } from 'api';
import { getSessionId } from 'util/session';
import { getGraphicCaptchaUrl } from 'util/graphicCaptcha';
import { useDispatch } from 'react-redux';
import { afterLogin } from 'model/login';

interface IProps {}

interface FormData {
  mobile: string;
  password: string;
  confirmPassword: string;
  agreement: boolean;
  graphicCaptcha: string;
}

const LoginWithPassword: React.FunctionComponent<IProps> = () => {
  const [form] = Form.useForm<FormData>();
  const dispatch = useDispatch();
  const [stateData, setStateData] = useState({
    loginLoading: false,
    isUserRegistered: true,
    graphicCaptchaUrl: '',
    accountError: '',
    graphicCaptchaError: '',
    passwordError: ''
  });
  const [formState, setFormState] = useState({ mobile: '', password: '', confirmPassword: '', agreement: false, graphicCaptcha: '' });

  function onFieldsChange() {
    const newData = form.getFieldsValue();
    setFormState((prevState) => ({ ...prevState, ...newData }));
  }

  function handleFromDataChange(newVal: Partial<typeof formStore.value>) {
    setFormState((prevState) => {
      const newState = { ...prevState, ...newVal };
      form.setFieldsValue(newState);
      return newState;
    });
  }

  function handleStateDataChange(newVal: Partial<typeof stateData>) {
    setStateData((prevState) => ({ ...prevState, ...newVal }));
  }

  const formStore = {
    value: formState,
    set: handleFromDataChange
  };

  const stateStore = {
    value: stateData,
    set: handleStateDataChange
  };

  const passowrdLoagin = new PasswordLoginPriv({
    API: {
      getSessionId,
      getGraphicCaptchaUrl,
      checkUserRegistered: (useName: string) => Pivot.checkUserRegistered(useName).toPromise(),
      loginByPassword: (data) => Pivot.loginByPassword(data).toPromise(),
      registerByPassword: (data) => Pivot.registerByPassword(data).toPromise(),
      getAuthConfig: () => Pivot.getAuthConfig().toPromise()
    },
    formStore: formStore as any,
    stateStore
  });

  async function handlePasswordLogin() {
    const res = await form.validateFields().catch(noop);
    if (!res) return;

    // 注册校验
    const isRegistered = await passowrdLoagin.checkUserRegistered();
    if (!isRegistered) return;

    const data = await passowrdLoagin.fetchPasswordLogin();
    if (!data) return;
    console.log('data', data);
    // 登录成功后跳转
    dispatch(
      afterLogin({
        token: data.access_token,
        userId: data.userId,
        mobile: formStore.value.mobile
      })
    );
  }

  async function handlePasswordRegister() {
    const res = await form.validateFields().catch(noop);
    if (!res) return;
    const data = await passowrdLoagin.fetchPasswordRegister();
    if (!data) return;
    console.log('data', data);
    // 登录成功后跳转
    dispatch(
      afterLogin({
        token: data.access_token,
        userId: data.userId,
        mobile: formStore.value.mobile
      })
    );
  }

  const { mobile, password, confirmPassword, graphicCaptcha } = form.getFieldsValue();
  const btnEnable = mobile && password && (stateData.isUserRegistered || confirmPassword) && (!stateData.graphicCaptchaUrl || graphicCaptcha);

  return (
    <div className={styles.main}>
      <div className={styles.mainTitleContainer}>
        <div className={styles.mainTitle}>账号登录</div>
      </div>
      <div className={styles.formWrapper}>
        <Form form={form} onFieldsChange={onFieldsChange} initialValues={formStore.value}>
          <LoginAccountItem name="mobile" help={stateData.accountError} onChange={passowrdLoagin.handleUserNameChange} />
          <LoginPasswordItem name="password" help={stateData.passwordError} type="login" />
          {!stateData.isUserRegistered && <LoginPasswordItem name="confirmPassword" type="confirm" />}
          <LoginGraphicCapatchaItem
            name="graphicCaptcha"
            help={stateData.graphicCaptchaError}
            onReset={passowrdLoagin.refrashGraphicCaptchaUrl}
            src={stateData.graphicCaptchaUrl}
          />
          <div className={styles.buttonWrapper}>
            <Button
              disabled={!btnEnable}
              loading={stateData.loginLoading}
              type="primary"
              block
              size="large"
              htmlType="submit"
              onClick={stateData.isUserRegistered ? handlePasswordLogin : handlePasswordRegister}
            >
              登录/注册
            </Button>
          </div>
          <LoginAgreementItem name="agreement" />
        </Form>
      </div>
    </div>
  );
};

export default LoginWithPassword;
